import { EQuoteSlaPolicyCode, EQuoteSlaType, EQuoteStatus, IQuote, IQuoteSla } from 'types/quote.types';
import { SLAStatus } from 'views/Quote/constants/quoteSLa.constants';

const ClassNameBySLAStatus: Record<SLAStatus | string, string> = {
  ON_TIME: 'info',
  WARNING: 'warning',
  EXPIRED: 'danger'
};

const calcSLAStatusCode = (sla: IQuoteSla): SLAStatus | undefined => {
  const { startsAt, expiresAt, seventyPercentAt } = sla ?? {};

  if (startsAt && expiresAt && seventyPercentAt) {
    const now = new Date();
    const startsAtDate = new Date(startsAt);
    const expiresAtDate = new Date(expiresAt);
    const seventyPercentAtDate = new Date(seventyPercentAt);

    if (now >= expiresAtDate) {
      return SLAStatus.EXPIRED;
    } else if (now >= seventyPercentAtDate) {
      return SLAStatus.WARNING;
    } else if (now >= startsAtDate) {
      return SLAStatus.ON_TIME;
    }
  }
};

export const getSLAStatus = (quote: IQuote) => {
  if (quote.statusCode === EQuoteStatus.TO_QUOTE) {
    const sla = quote.slas?.find(sla => sla?.slaTypeCode === EQuoteSlaType.PROCUREMENT_RESPONSE_TIME);
    const slaStatus = sla ? calcSLAStatusCode(sla) : undefined;
    const className = slaStatus ? ClassNameBySLAStatus[slaStatus] : '';

    return {
      sla,
      isCTO: sla?.slaPolicyCode === EQuoteSlaPolicyCode.CTO,
      className
    };
  }
  if (quote.statusCode === EQuoteStatus.PENDING_APPROVAL || quote.statusCode === EQuoteStatus.EXPIRED) {
    const sla = quote.slas?.find(sla => sla?.slaTypeCode === EQuoteSlaType.CLIENT_RESPONSE_TIME);
    const slaStatus = sla ? calcSLAStatusCode(sla) : undefined;
    const className = slaStatus ? ClassNameBySLAStatus[slaStatus] : '';

    return {
      sla,
      className
    };
  }
};
